class ProductVideoGallery {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Bind trigger button events
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-video-gallery-trigger]')) {
        e.preventDefault();
        this.openLightbox(e.target.closest('[data-video-gallery-trigger]'));
      }
    });

    // Bind close events
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-video-gallery-close]')) {
        e.preventDefault();
        this.closeLightbox();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeLightbox();
      }
    });

    // Close on overlay click
    document.addEventListener('click', (e) => {
      if (
        e.target.closest('[data-video-gallery-lightbox]') &&
        !e.target.closest('.product-video-gallery__lightbox-content')
      ) {
        this.closeLightbox();
      }
    });
  }

  openLightbox(triggerButton) {
    const lightbox = document.querySelector('[data-video-gallery-lightbox]');
    if (!lightbox) return;

    // Show lightbox
    lightbox.style.display = 'flex';

    // Trigger animation
    requestAnimationFrame(() => {
      lightbox.classList.add('is-active');
    });

    // Pause any currently playing videos in the main gallery
    this.pauseMainGalleryVideos();

    // Focus management
    const closeButton = lightbox.querySelector('[data-video-gallery-close]');
    if (closeButton) {
      closeButton.focus();
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    const lightbox = document.querySelector('[data-video-gallery-lightbox]');
    if (!lightbox) return;

    // Remove active class for animation
    lightbox.classList.remove('is-active');

    // Wait for animation to complete
    setTimeout(() => {
      lightbox.style.display = 'none';

      // Resume body scroll
      document.body.style.overflow = '';

      // Pause all videos in lightbox
      this.pauseLightboxVideos();
    }, 300);
  }

  pauseMainGalleryVideos() {
    const mainGalleryVideos = document.querySelectorAll('.product__media-item video, .product__media-item iframe');
    mainGalleryVideos.forEach((video) => {
      if (video.tagName === 'VIDEO') {
        video.pause();
      } else if (video.tagName === 'IFRAME') {
        // For external videos, we can't directly pause them, but we can try to stop them
        const src = video.src;
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          video.src = src;
        } else if (src.includes('vimeo.com')) {
          video.src = src;
        }
      }
    });
  }

  pauseLightboxVideos() {
    const lightboxVideos = document.querySelectorAll(
      '.product-video-gallery__lightbox video, .product-video-gallery__lightbox iframe'
    );
    lightboxVideos.forEach((video) => {
      if (video.tagName === 'VIDEO') {
        video.pause();
      } else if (video.tagName === 'IFRAME') {
        // For external videos, we can't directly pause them, but we can try to stop them
        const src = video.src;
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          video.src = src;
        } else if (src.includes('vimeo.com')) {
          video.src = src;
        }
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductVideoGallery();
});

// Initialize for dynamic content (e.g., AJAX loaded products)
document.addEventListener('shopify:section:load', () => {
  new ProductVideoGallery();
});
